"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _utils = require("@package/utils");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _useGetSenderShops = _interopRequireDefault(require("./hooks/useGetSenderShops"));

var _useGetRecipientShops = _interopRequireDefault(require("./hooks/useGetRecipientShops"));

var _useGetSelectedAccount = _interopRequireDefault(require("./hooks/useGetSelectedAccount"));

var _useGetSelectedSenderShop = _interopRequireDefault(require("./hooks/useGetSelectedSenderShop"));

var _useGetAccountsFromSenderShop = _interopRequireDefault(require("./hooks/useGetAccountsFromSenderShop"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function HOC() {
  try {
    var handleSubmit = function handleSubmit(data) {
      dispatch((0, _functionalButton.createTransfer)(data));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    var senderShops = (0, _useGetSenderShops["default"])();
    var recipientShops = (0, _useGetRecipientShops["default"])();
    var defaultSenderShop = (0, _useGetSelectedSenderShop["default"])(senderShops);
    var accounts = (0, _useGetAccountsFromSenderShop["default"])(defaultSenderShop);
    var defaultAccount = (0, _useGetSelectedAccount["default"])(accounts);
    (0, _hoc.useMount)(function () {
      dispatch((0, _functionalButton.getShops)({
        minAmount: 10,
        include: ['additionalSettings', 'payoutMethods', 'transferRoutes']
      }));
    });
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      senderShops: senderShops,
      recipientsShops: recipientShops,
      accounts: accounts,
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      },
      initialValues: {
        externalId: (0, _utils.uuid)(),
        sender: defaultSenderShop,
        account: defaultAccount,
        'amount-debit': null,
        'amount-credit': null
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;